import apiService from '../apiService';

const SUPER_ADMIN_URL = '/super-admin'
const companySettings = {
  // Normal Admin / Tenant
  async getCompanySettings() {
    try {
      const response = await apiService.get(`/settings/global`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async restoreDefaultSettings() {
    try {
      const response = await apiService.post(`/settings/global/restore`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  
  async updateCompanySettings(payload) {
    try {
      const response = await apiService.post(`/settings/global`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Super Admin
  async superAdminGetCompanySettings() {
    try {
      const response = await apiService.get(`${SUPER_ADMIN_URL}/global`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminUpdateCompanySettings(payload) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/global`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminRestoreDefaultSettings() {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/global/restore`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateCompanyUsage(payload) {
    try {
      const response = await apiService.post(`/settings/global/globalSetting`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Public (no auth) — this node's company logo for pre-auth pages.
  // Returns { company_logo: url | null }, the same URL the dashboard renders.
  async getPublicCompanyLogo() {
    try {
      const response = await apiService.get(`/branding/company-logo`);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default companySettings;